import React from "react";
import { useTranslation } from "react-i18next";

const TeamMemberCard = ({ member, onRemove, onCancel, isOwner }) => {
  const { t, i18n } = useTranslation();

  const doctor = member.doctor || member.user || {};
  const doctorName = doctor.name ||
    (doctor.first_name || doctor.last_name
      ? `${doctor.first_name || ""} ${doctor.last_name || ""}`.trim()
      : t("manageTeam.current.unknownDoctor"));

  const profileImageUrl = doctor.profile_image_url || member.user?.profile_image_url;
  const role = member.role || "doctor";
  const isPending = member.status === "pending";
  const isClinicOwner = member.is_owner === true || member.is_owner === 1 || member.is_owner === "1";

  const roleClass = isClinicOwner
    ? "team-role-owner"
    : role === "clinic_moderator"
      ? "team-role-moderator"
      : "team-role-doctor";

  const roleLabel = isClinicOwner
    ? t("manageTeam.current.owner")
    : t(`manageTeam.roles.${role === "clinic_moderator" ? "CLINIC_MODERATOR" : "VETERINARIAN"}`, {
        defaultValue: role === "clinic_moderator" ? "Clinic Moderator" : "Veterinarian",
      });

  return (
    <div className={`team-card ${isClinicOwner ? "team-card-owner" : ""}`} dir={i18n.dir()} lang={i18n.language}>
      <img
        src={profileImageUrl || "/images/doctor.png"}
        alt={doctorName}
        className="team-avatar"
        onError={(e) => (e.target.src = "/images/doctor.png")}
      />
      <h4 className="team-name">{doctorName}</h4>
      <span className={`team-role ${roleClass}`}>{roleLabel}</span>

      <div className={`team-status ${isPending ? "team-status-pending" : "team-status-active"}`}>
        <span className="team-status-dot" />
        {t(`manageTeam.status.${member.status}`, {
          defaultValue: member.status?.charAt(0).toUpperCase() + member.status?.slice(1),
        })}
      </div>

      <div className="team-card-actions">
        {isPending ? (
          <button
            type="button"
            className="team-action-btn team-action-btn-danger"
            onClick={() => onCancel(member.id)}
          >
            {t("manageTeam.invite.cancel", "Cancel Invitation")}
          </button>
        ) : (
          <>
            {!isClinicOwner && (
              <button
                type="button"
                className="team-action-btn team-action-btn-danger"
                onClick={() => onRemove(member.id)}
              >
                {t("manageTeam.current.remove", "Remove")}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TeamMemberCard;
